import { DialogActions, DialogContent, Typography } from "@material-ui/core";
import { Button } from "components";
import { usePopup } from "hooks/usePopup";
import { useRef, useState } from "react";
import productBaseService from "services/productBaseService";
import { Dialog, Drawer } from "shared";
import Cookies from "universal-cookie";

import { buildProductBaseUpdatePayload } from "../../productBaseUpdatePayload";
import { Form } from "../Form";

export const ModalCreated = ({
  isOpen,
  refresh,
  close,
  productCategoryData,
  productSubCategoryData
}) => {
  const formRef = useRef(null);
  const [isOmieAlertOpen, setIsOmieAlertOpen] = useState(false);
  const { addPopup } = usePopup();
  const cookies = new Cookies();
  const distributionCenterId = cookies.get("distributionCenterId");

  const handleClose = () => close();

  const onSubmit = async data => {
    try {
      const payload = {
        ...data,
        distributionCenterId
      };
      const response = await productBaseService.postProductBase(payload);
      const { data: product } = response;

      if (data.base64) {
        await productBaseService.updateProductBase(
          buildProductBaseUpdatePayload({
            id: product.data.id,
            values: data,
            currentImage: null
          })
        );
      }

      addPopup({
        type: "success",
        title: "Produdo base criado com sucesso."
      });

      setIsOmieAlertOpen(true);

      handleClose();

      refresh();
    } catch (error) {
      if (error?.response?.status !== 401) {
        addPopup({
          type: "error",
          title: "Erro ao criar produto base."
        });
      }
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        title="Novo produto"
      >
        <Form
          onSubmit={onSubmit}
          ref={formRef}
          productCategoryData={productCategoryData}
          productSubCategoryData={productSubCategoryData}
        />
      </Drawer>

      <Dialog
        open={isOmieAlertOpen}
        handleClose={() => setIsOmieAlertOpen(false)}
        title="Atenção"
        maxWidth="30rem"
      >
        <DialogContent>
          <Typography>
            Cadastre este produto no Omie. Sem o cadastro no Omie, a NF não será
            emitida e a operação ficará travada.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => setIsOmieAlertOpen(false)}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
